import { API_BASE_URL } from "@/config";
import { validate_form } from "@/utils/signio_validation.js";
import { allow_currency } from "@/utils/validations.js";


export default {
  name: "CostInputGrid",
  emits: ["validity-change", "previous"],
  data() {
    const config = [
      {
        key: "sumExpensesCustomerBondPayment",
        question: "Your bond payment",
        question_type: "number",
        short_label: "Bond Payment",
      },
      {
        key: "sumExpensesSpouseBondPayment",
        question: "Spouse's bond payment",
        question_type: "number",
        short_label: "Spouse Bond",
      },
      {
        key: "sumExpensesCustomerRent",
        question: "Your rent",
        question_type: "number",
        short_label: "Rent",
      },
      {
        key: "sumExpensesSpouseRent",
        question: "Spouse's rent",
        question_type: "number",
        short_label: "Spouse Rent",
      },
      {
        key: "totalCustomerBondAndRentPayment",
        question: "Total bond and rent payment",
        question_type: "number",
        short_label: "Total Bond & Rent",
      },
      {
        key: "sumExpensesCustomerRates",
        question: "Your rates, water, and electricity expenses",
        question_type: "number",
        short_label: "Rates & Utilities",
      },
      {
        key: "sumExpensesSpouseRates",
        question: "Spouse's rates, water, and electricity expenses",
        question_type: "number",
        short_label: "Spouse Utilities",
      },
      {
        key: "sumExpensesCustomerVehicleInstallments",
        question: "Your vehicle installments",
        question_type: "number",
        short_label: "Vehicle Inst.",
      },
      {
        key: "sumExpensesSpouseVehicleInstallments",
        question: "Spouse's vehicle installments",
        question_type: "number",
        short_label: "Spouse Vehicle",
      },
      {
        key: "sumExpensesCustomerLoanRepayments",
        question: "Your personal loan repayments",
        question_type: "number",
        short_label: "Loan Repayments",
      },
      {
        key: "sumExpensesSpouseLoanRepayments",
        question: "Spouse's personal loan repayments",
        question_type: "number",
        short_label: "Spouse Loans",
      },
      {
        key: "sumExpensesCustomerCreditCardRepayments",
        question: "Your credit card repayments",
        question_type: "number",
        short_label: "Credit Cards",
      },
      {
        key: "sumExpensesSpouseCreditCardRepayments",
        question: "Spouse's credit card repayments",
        question_type: "number",
        short_label: "Spouse Cards",
      },
      {
        key: "sumExpensesCustomerFurnitureAccounts",
        question: "Your furniture account expenses",
        question_type: "number",
        short_label: "Furniture Accts",
      },
      {
        key: "sumExpensesSpouseFurnitureAccounts",
        question: "Spouse's furniture account expenses",
        question_type: "number",
        short_label: "Spouse Furniture",
      },
      {
        key: "sumExpensesCustomerClothingAccounts",
        question: "Your clothing account expenses",
        question_type: "number",
        short_label: "Clothing Accts",
      },
      {
        key: "sumExpensesSpouseClothingAccounts",
        question: "Spouse's clothing account expenses",
        question_type: "number",
        short_label: "Spouse Clothing",
      },
      {
        key: "sumExpensesCustomerOverdraftRepayments",
        question: "Your overdraft repayments",
        question_type: "number",
        short_label: "Overdraft Repay.",
      },
      {
        key: "sumExpensesSpouseOverdraftRepayments",
        question: "Spouse's overdraft repayments",
        question_type: "number",
        short_label: "Spouse Overdraft",
      },
      {
        key: "sumExpensesCustomerInsurancePayments",
        question: "Your insurance payments",
        question_type: "number",
        short_label: "Insurance",
      },
      {
        key: "sumExpensesCustomerTelephonePayments",
        question: "Your telephone payments",
        question_type: "number",
        short_label: "Telephone",
      },
      {
        key: "sumExpensesSpouseTelephonePayments",
        question: "Spouse's telephone payments",
        question_type: "number",
        short_label: "Spouse Telephone",
      },
      {
        key: "sumExpensesCustomerTransport",
        question: "Your transport costs",
        question_type: "number",
        short_label: "Transport",
      },
      {
        key: "sumExpensesSpouseTransport",
        question: "Spouse's transport costs",
        question_type: "number",
        short_label: "Spouse Transport",
      },
      {
        key: "sumExpensesCustomerFoodAndEntertainment",
        question: "Your food and entertainment expenses",
        question_type: "number",
        short_label: "Food & Ent.",
      },
      {
        key: "sumExpensesSpouseFoodAndEntertainment",
        question: "Spouse's food and entertainment expenses",
        question_type: "number",
        short_label: "Spouse Food",
      },
      {
        key: "sumExpensesCustomerEducationCosts",
        question: "Your education costs",
        question_type: "number",
        short_label: "Education",
      },
      {
        key: "sumExpensesSpouseEducationCosts",
        question: "Spouse's education costs",
        question_type: "number",
        short_label: "Spouse Education",
      },
      {
        key: "sumExpensesCustomerMaintenance",
        question: "Your maintenance expenses",
        question_type: "number",
        short_label: "Maintenance",
      },
      {
        key: "sumExpensesSpouseMaintenance",
        question: "Spouse's maintenance expenses",
        question_type: "number",
        short_label: "Spouse Maintenance",
      },
      {
        key: "sumExpensesCustomerHouseholdExpenses",
        question: "Your household expenses",
        question_type: "number",
        short_label: "Household Exp.",
      },
      {
        key: "sumExpensesSpouseHouseholdExpenses",
        question: "Spouse's household expenses",
        question_type: "number",
        short_label: "Spouse Household",
      },
      {
        key: "sumExpensesCustomerSecurity",
        question: "Your security expenses",
        question_type: "number",
        short_label: "Security",
      },
      {
        key: "sumExpensesSpouseSecurity",
        question: "Spouse's security expenses",
        question_type: "number",
        short_label: "Spouse Security",
      },
      {
        key: "sumExpensesCustomerOtherExpenses",
        question: "Your other expenses",
        question_type: "number",
        short_label: "Other Exp.",
      },
      {
        key: "sumExpensesSpouseOtherExpenses",
        question: "Spouse's other expenses",
        question_type: "number",
        short_label: "Spouse Other",
      },
      {
        key: "sumExpensesCustomerOtherExpensesDesc",
        question: "Description of your other expenses",
        question_type: "text",
      },
      {
        key: "sumExpensesSpouseOtherExpensesDesc",
        question: "Description of Spouse's other expenses",
        question_type: "text",
      },
      {
        key: "customerTotalExpenses",
        question: "Your total expenses",
        question_type: "number",
        short_label: "Total Expenses",
      },
      {
        key: "spouseTotalExpenses",
        question: "Spouse's total expenses",
        question_type: "number",
        short_label: "Spouse Total",
      },
      {
        key: "customerDisposableIncome",
        question: "Your disposable income",
        question_type: "number",
        short_label: "Disposable Inc.",
      },
      {
        key: "spouseDisposableIncome",
        question: "Spouse's disposable income",
        question_type: "number",
        short_label: "Spouse Disposable",
      },
    ];
    const main_number_fields = [];
    const spouse_number_fields = [];
    const main_text_fields = [];
    const spouse_text_fields = [];
    config.forEach((f) => {
      if (f.question_type === "number") {
        if (!f.key.toLowerCase().includes("spouse")) main_number_fields.push(f);
        else spouse_number_fields.push(f);
      } else if (f.question_type === "text") {
        if (!f.key.toLowerCase().includes("spouse")) main_text_fields.push(f);
        else spouse_text_fields.push(f);
      }
    });
    const form_data = {};
    config.forEach((f) => {
      form_data[f.key] = f.question_type === "number" ? "" : "";
    });

    // Category grouping for main
    const housing_fields = main_number_fields.filter((f) =>
      [
        "sumExpensesCustomerBondPayment",
        "sumExpensesCustomerRent",
        "totalCustomerBondAndRentPayment",
      ].includes(f.key)
    );
    const utilities_fields = main_number_fields.filter(
      (f) => f.short_label === "Rates & Utilities"
    );
    const loans_fields = main_number_fields.filter((f) =>
      ["Loan Repayments", "Credit Cards", "Overdraft Repay."].includes(
        f.short_label
      )
    );
    const install_fields = main_number_fields.filter((f) =>
      ["Vehicle Inst.", "Furniture Accts", "Clothing Accts"].includes(
        f.short_label
      )
    );
    const other_fields = main_number_fields.filter((f) =>
      [
        "Insurance",
        "Telephone",
        "Transport",
        "Food & Ent.",
        "Education",
        "Maintenance",
        "Household Exp.",
        "Security",
        "Other Exp.",
      ].includes(f.short_label)
    );
    const totals_fields = main_number_fields.filter((f) =>
      ["Total Expenses", "Disposable Inc."].includes(f.short_label)
    );
    // Category grouping for spouse
    const spouse_housing = spouse_number_fields.filter((f) =>
      ["Spouse Bond", "Spouse Rent", "Total Bond & Rent"].includes(
        f.short_label
      )
    );
    const spouse_utilities = spouse_number_fields.filter(
      (f) => f.short_label === "Spouse Utilities"
    );
    const spouse_loans = spouse_number_fields.filter((f) =>
      ["Spouse Loans", "Spouse Cards", "Spouse Overdraft"].includes(
        f.short_label
      )
    );
    const spouse_installs = spouse_number_fields.filter((f) =>
      ["Spouse Vehicle", "Spouse Furniture", "Spouse Clothing"].includes(
        f.short_label
      )
    );
    const spouse_other = spouse_number_fields.filter((f) =>
      [
        "Insurance",
        "Telephone",
        "Transport",
        "Spouse Food",
        "Spouse Education",
        "Spouse Maintenance",
        "Spouse Household",
        "Spouse Security",
        "Spouse Other",
      ].includes(f.short_label)
    );
    const spouse_totals = spouse_number_fields.filter((f) =>
      ["Spouse Total", "Spouse Disposable"].includes(f.short_label)
    );
    return {
      main_number_fields,
      spouse_number_fields,
      main_text_fields,
      spouse_text_fields,
      form_data,
      collapsed_sections: {
        main_expenses: false,
        spouse_expenses: false,
      },
      housing_fields,
      utilities_fields,
      loans_fields,
      install_fields,
      other_fields,
      totals_fields,
      spouse_housing,
      spouse_utilities,
      spouse_loans,
      spouse_installs,
      spouse_other,
      spouse_totals,
      is_married: false,
      income: 0.00,
      spouse_income: 0.00
    };
  },
  mounted() {
    this.fetch_sygnio_answers();
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  methods: {
    allow_currency,
    previous() {
      this.$emit("previous");
    },
    toggle(section) {
      this.collapsed_sections[section] = !this.collapsed_sections[section];
    },
    on_amount_input(field) {
      const val = this.form_data[field.key].replace(/,/g, "");
      this.form_data[field.key] = val;
      this.auto_calculate_totals();
    },
    format_amount(field) {
      const key = field.key;
      let val = parseFloat(this.form_data[key]);
      val = isNaN(val) ? 0 : val;
      this.form_data[key] = val.toFixed(2);
      this.auto_calculate_totals();
    },
    auto_calculate_totals() {
      // Calculate main total expenses
      const main_expense_keys = this.main_number_fields
        .map(f => f.key)
        .filter(key => !['customerTotalExpenses', 'customerDisposableIncome', 'totalCustomerBondAndRentPayment'].includes(key));
      let total = 0;
      main_expense_keys.forEach(key => {
        let v = parseFloat(this.form_data[key]);
        if (!isNaN(v)) total += v;
      });
      this.form_data['customerTotalExpenses'] = total.toFixed(2);

      // Calculate spouse total expenses
      const spouse_expense_keys = this.spouse_number_fields
        .map(f => f.key)
        .filter(key => !['spouseTotalExpenses', 'spouseDisposableIncome'].includes(key));
      let spouse_total = 0;
      spouse_expense_keys.forEach(key => {
        let v = parseFloat(this.form_data[key]);
        if (!isNaN(v)) spouse_total += v;
      });
      this.form_data['spouseTotalExpenses'] = spouse_total.toFixed(2);

      if (!isNaN(this.income)) {
        this.form_data['customerDisposableIncome'] = (this.income - total).toFixed(2);
      }

      if (!isNaN(this.spouse_income)) {
        this.form_data['spouseDisposableIncome'] = (this.spouse_income - spouse_total).toFixed(2);
      }
    },
    submit_section() {
      const token = localStorage.getItem("token");
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/sygnio_answer/`;
      
      var errors = validate_form(this.form_data);
      if (errors.length > 0) {
        {
          const msg = errors
            .map(err => {
              return `${err.error}`
            })
            .join("\n")

          Swal.fire({
            title: "Validation Error",
            text: msg,
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          })
        }
        return;
      }
      
      const answers = Object.keys(this.form_data).map((key) => ({
        answer: this.form_data[key],
        api_form_field: key,
      }));
      $.ajax({
        type: "POST",
        url: service_api,
        headers: { Authorization: `Token ${token}` },
        data: JSON.stringify({
          answers,
          workflow_id: this.$store.getters.get_workflow_id,
        }),
        contentType: "application/json",
        success: (response) => {
          if (response.status === "success") {
            Swal.fire({
              title: "Success",
              text: "Your information has been submitted successfully!",
              icon: "success",
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false,
            }).then(() => {
              this.$emit("validity-change", true)
            });
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to submit the information, try again later.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        },
      });
    },
    fetch_sygnio_answers() {
      const token = localStorage.getItem("token");
      const service_api = `${API_BASE_URL}/verify_api/financial_information_api/get_sygnio_question_answers/`;

      $.ajax({
        type: "POST",
        url: service_api,
        headers: {
          Authorization: `Token ${token}`,
        },
        data: JSON.stringify({ workflow_id: this.workflow_id }),
        contentType: "application/json",
        success: (response) => {
          if (response.status === 'success' && response.data) {
            const data = response.data;
            if (Array.isArray(data)) {
              data.forEach(item => {
                const key = item.api_form_field;
                const value = item.answer;
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                }
                if (key === 'customerMaritalStatus') {
                  this.is_married = (value === 'Married');
                }
                else if (key === 'customerTotalMonthlyIncome'){
                    this.income = parseFloat(value).toFixed(2) || 0.00;
                }
                else if (key === 'spouseTotalMonthlyIncome'){
                    this.spouse_income = parseFloat(value).toFixed(2) || 0.00;
                }
                this.auto_calculate_totals();
              });
            } else if (typeof data === 'object') {
              Object.keys(data).forEach(key => {
                const value = data[key];
                if (this.form_data[key] !== undefined) {
                  this.form_data[key] = value;
                }
                if (key === 'customerMaritalStatus') {
                  this.is_married = (value === 'Married');
                }
                else if (key === 'customerTotalMonthlyIncome'){
                    this.income = parseFloat(value).toFixed(2) || 0.00;
                }
                else if (key === 'spouseTotalMonthlyIncome'){
                    this.spouse_income = parseFloat(value).toFixed(2) || 0.00;
                }
                this.auto_calculate_totals();
              });
            }
          }
        },
        error: () => {
          Swal.fire({
            title: "Error",
            text: "Failed to fetch the answers, please try again later.",
            icon: "error",
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false,
          });
        },
      });
    },
  },
};
